import { ClassifierCategory, ClassifierType } from 'src/api/requests'
import { useClassifierId } from 'src/hooks'

import { AidsCategoryLetter } from '../utils/aidsCategory'

/** Ids of the classifiers Form 058-1/e selects from (fields 26, 43, 55.2 and its clinical conditions). */
export const useHivAnamnesisClassifiers = () => {
  const motherStatusId = useClassifierId(
    ClassifierType.HIV_MOTHER_STATUS,
    ClassifierCategory.TREATMENT
  )
  const transmissionRouteId = useClassifierId(
    ClassifierType.HIV_TRANSMISSION_ROUTE,
    ClassifierCategory.TREATMENT
  )
  const aidsClinicalCategoryId = useClassifierId(
    ClassifierType.AIDS_CLINICAL_CATEGORY,
    ClassifierCategory.TREATMENT
  )
  const aidsClinicalConditionsAId = useClassifierId(
    ClassifierType.AIDS_CLINICAL_CONDITIONS_A,
    ClassifierCategory.TREATMENT
  )
  const aidsClinicalConditionsBId = useClassifierId(
    ClassifierType.AIDS_CLINICAL_CONDITIONS_B,
    ClassifierCategory.TREATMENT
  )
  const aidsClinicalConditionsCId = useClassifierId(
    ClassifierType.AIDS_CLINICAL_CONDITIONS_C,
    ClassifierCategory.TREATMENT
  )

  /** The clinical conditions classifier of an AIDS clinical category letter (a, b or c). */
  const aidsClinicalConditionsIdOf = (letter?: AidsCategoryLetter) =>
    letter
      ? {
          a: aidsClinicalConditionsAId,
          b: aidsClinicalConditionsBId,
          c: aidsClinicalConditionsCId
        }[letter]
      : undefined

  return {
    motherStatusId,
    transmissionRouteId,
    aidsClinicalCategoryId,
    aidsClinicalConditionsIdOf
  }
}
